import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import styled from 'styled-components';
import middleBannerBg from '../assets/images/Home/MiddleBanner.webp';

const ServicesSectionWrapper = styled.section`
  position: relative;
  background-image: url(${middleBannerBg});
  background-size: cover;
  background-position: center;
  padding: 100px 0;
  margin: 80px 0;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.8);
    z-index: 0;
  }
`;

const SectionContent = styled.div`
  position: relative;
  z-index: 1;
  text-align: center;
`;

const SectionTitle = styled.div`
  margin-bottom: 80px;
  
  h2 {
    font-size: 35px;
    margin-bottom: 0;
    color: white;
    font-weight: 500;
  }
  
  h2 span {
    color: #e4880f;
  }
  
  p {
    color: white;
    font-family: 'Montserrat', sans-serif;
    font-size: 16px;
    font-weight: 400;
    letter-spacing: 2px;
    text-transform: uppercase;
    max-width: 800px;
    margin: 5px auto 0;
  }
`;

const ServiceItem = styled.div`
  margin-bottom: ${props => props.noMargin ? '0' : '40px'};
  
  h3 {
    font-size: 28px;
    margin-bottom: 15px;
    color: white;
    font-weight: 400;
    text-transform: capitalize;
  }
  
  h3 span {
    color: #e4880f;
  }
  
  p {
    color: white;
    font-family: 'Montserrat', sans-serif;
    font-size: 14px;
    margin: 0 auto;
  }
`;

const OrangeLine = styled.div`
  width: 100px;
  height: 3px;
  background-color: #e4880f;
  margin: 20px auto 15px;
`;

const ServiceRow = styled(Row)`
  margin-bottom: ${props => props.noMargin ? '0' : '40px'};
`;

const ServicesSection = () => {
  const serviceItems = [
    {
      id: 1,
      titleColor: 'CNC',
      titleWhite: 'Machining',
      description: 'Precision milling, turning, and drilling using computer-controlled machines.'
    },
    {
      id: 2,
      titleColor: 'Laser',
      titleWhite: 'Cutting',
      description: 'High-precision cutting of metal sheets using laser technology.'
    },
    {
      id: 3,
      titleColor: 'Welding',
      titleWhite: 'Services',
      description: 'MIG, TIG, and arc welding for joining metal components.'
    },
    {
      id: 4,
      titleColor: 'Sheet Metal',
      titleWhite: 'Fabrication',
      description: 'Forming, punching, and shaping sheet metal into desired structures.'
    },
    {
      id: 5,
      titleColor: 'Powder Coating',
      titleWhite: '& Finishing',
      description: 'Protective and decorative coatings to enhance durability and aesthetics.'
    },
    {
      id: 6,
      titleColor: 'Metal Stamping',
      titleWhite: '& Forming',
      description: 'High-volume production of metal parts using stamping presses.'
    },
    {
      id: 7,
      titleColor: 'Structural Steel',
      titleWhite: 'Fabrication',
      description: 'Forming, punching, and shaping sheet metal into desired structures.'
    },
    {
      id: 8,
      titleColor: 'Custom Metal',
      titleWhite: 'Fabrication',
      description: 'Cutting, bending, and assembling metal parts for various applications.'
    },
    {
      id: 9,
      titleColor: 'Assembly',
      titleWhite: '& Integration',
      description: 'Assembling fabricated parts into complete products or systems.'
    },
    {
      id: 10,
      titleColor: 'Prototyping',
      titleWhite: '& Product Development',
      description: 'Creating metal prototypes for testing and refinement.'
    }
  ];

  return (
    <ServicesSectionWrapper className="my-0">
      <Container>
        <SectionContent>
          <SectionTitle>
            <h2 className="fs-ss-35">Our <span>Services</span></h2>
            <p>ADVANCED CUTTING & ENGINEERING FOR UNMATCHED RESULTS</p>
            <OrangeLine />
          </SectionTitle>
          
          <ServiceRow>
            {serviceItems.slice(0, 3).map(service => (
              <Col md={4} key={service.id}>
                <ServiceItem>
                  <h3 className="fs-ss-28"><span>{service.titleColor}</span> {service.titleWhite}</h3>
                  <div className="col-10 mx-auto">
                    <p>{service.description}</p>
                  </div>
                </ServiceItem>
              </Col>
            ))}
          </ServiceRow>
          
          <ServiceRow>
            {serviceItems.slice(3, 6).map(service => (
              <Col md={4} key={service.id}>
                <ServiceItem>
                  <h3 className="fs-ss-28"><span>{service.titleColor}</span> {service.titleWhite}</h3>
                  <div className="col-10 mx-auto">
                    <p>{service.description}</p>
                  </div>
                </ServiceItem>
              </Col>
            ))}
          </ServiceRow>
          
          <ServiceRow>
            {serviceItems.slice(6, 9).map(service => (
              <Col md={4} key={service.id}>
                <ServiceItem>
                  <h3 className="fs-ss-28"><span>{service.titleColor}</span> {service.titleWhite}</h3>
                  <div className="col-10 mx-auto">
                    <p>{service.description}</p>
                  </div>
                </ServiceItem>
              </Col>
            ))}
          </ServiceRow>
          
          <ServiceRow noMargin className="justify-content-center">
            <Col md={4}>
              <ServiceItem noMargin className="text-center">
                <h3 className="fs-ss-28"><span>{serviceItems[9].titleColor}</span> {serviceItems[9].titleWhite}</h3>
                <div className="mx-auto">
                  <p>{serviceItems[9].description}</p>
                </div>
              </ServiceItem>
            </Col>
          </ServiceRow>
        </SectionContent>
      </Container>
    </ServicesSectionWrapper>
  );
};

export default ServicesSection; 